import { TrackingDetails } from '../../../tracking-api';
import { Model, defaultModel } from './schema';
import { LocalScorm2004Repository } from './local-scorm2004-repository';
import { reportNonFatalError } from '@/app/error-handling';
import { merge } from 'lodash'

export class LocalStorageLocalScorm2004Repository implements LocalScorm2004Repository {

  private key: string = '';

  public initialize(details: TrackingDetails): void {
    this.key = `${details.courseId}`;
  }

  public load(): Model {

    if (!this.key) { throw new Error('Coding error'); }

    const loaded = localStorage.getItem(this.key);
    if (!loaded) {
      return defaultModel();
    }

    try {
      const model = JSON.parse(loaded);

      // merge with the default
      const merged = merge(defaultModel(), model)
      return merged
    } catch (err) {
      reportNonFatalError(`Couldn't parse stored JSON, using default model.`, loaded);
      return defaultModel();
    }
  }

  public save(model: Model): void {

    if (!this.key) { throw new Error('Coding error'); }

    localStorage.setItem(this.key, JSON.stringify(model));
  }
}
